import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Calculatrice d'augmentation de salaire";
const DESCRIPTION =
  "Calculez une augmentation de salaire en pourcentage et visualisez immediatement le nouveau montant obtenu. Outil utile pour comparer une proposition, preparer une negotiation ou verifier une hausse annuelle.";
const KEYWORDS =
  "calculatrice augmentation salaire, calcul hausse salaire, pourcentage augmentation salaire, nouveau salaire, progression remuneration";
const OG_URL =
  "https://do-calculate.com/calculator/fr/salary-bonus-calculator/";
function SalaryBonusCalculator() {
  const [salary, setSalary] = useState("");
  const [percentage, setPercentage] = useState("");
  const [result, setResult] = useState(null);
  const [steps, setSteps] = useState([]);
  const [error, setError] = useState("");
  const handleCalculate = () => {
    try {
      if (!salary || !percentage) {
        setError("Veuillez entrer le salaire et le pourcentage.");
        return;
      }
      const basicSalary = parseFloat(salary);
      const bonusPercentage = parseFloat(percentage) / 100;
      const bonusAmount = (basicSalary * bonusPercentage).toFixed(2);
      const total = (parseInt(basicSalary) + parseInt(bonusAmount)).toFixed(2);
      const step1 = `Salaire de base: ${basicSalary}`;
      const step2 = `Pourcentage d'augmentation: ${bonusPercentage * 100}%`;
      const step3 = `Calcul de l'augmentation: ${basicSalary} × ${bonusPercentage} = ${bonusAmount}`;
      const step4 = `Salaire après augmentation: ${total}`;
      setSteps([step1, step2, step3, step4]);
      setResult(bonusAmount);
      setError("");
    } catch (err) {
      setError("Une erreur s'est produite lors du calcul. Veuillez réessayer.");
    }
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Cette calculatrice d augmentation de salaire vous permet d estimer rapidement le montant ajoute a votre remuneration a partir d un pourcentage de hausse. Elle est utile pour verifier une proposition d employeur, preparer un entretien annuel ou mesurer l effet d une revalorisation deja annoncee.
                </p>
                <p>
                  <strong>
                    Augmentation = Salaire de base × (Pourcentage d'augmentation ÷ 100)
                  </strong>
                </p>
                <p>
                  Saisissez simplement votre salaire de base puis le pourcentage d augmentation envisage. L outil affiche la valeur de la hausse et le nouveau total apres augmentation, avec les etapes du calcul pour verifier le resultat.
                </p>
                <p>
                  Vous pouvez ainsi comparer plusieurs hypotheses sans refaire les calculs a la main, par exemple pour une augmentation generale, une promotion ou une renegociation salariale.
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div>
                  <div>
                    <hr />
                    <div className="form-group" htmlFor="salary">
                      <label className="form-label ms-2" htmlFor="percentage">
                        Entrez le salaire de base
                      </label>
                      <input
                        id="salary"
                        type="number"
                        value={salary}
                        onChange={(e) => setSalary(e.target.value)}
                        placeholder="Entrez le salaire de base"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2">
                        Entrez le pourcentage d'augmentation (%)
                      </label>
                      <input
                        id="percentage"
                        type="number"
                        value={percentage}
                        onChange={(e) => setPercentage(e.target.value)}
                        placeholder="Entrez le pourcentage"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      Calculer                    </button>
                  </div>
                  <br />
                  { error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      Erreur: {error}
                    </p>
                  )}
                  {result &&  (
                    <>
                      <div className="p-3 mb-2 bg-success">
                        <h4 className="text-white">Résultat: {result} EUR</h4>
                      </div>
                      <div
                        className="p-3 mb-2 bg-info text-black"
                        style={{ width: "100%" }}
                      >
                        <p className="text-black">
                          <strong>Étapes:</strong>
                        </p>
                        <ul className="p-3 mb-2 bg-info text-black">
                          {steps.map((step, index) => (
                            <li key={index}>{step}</li>
                          ))}
                        </ul>
                      </div>
                    </>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Pourquoi faire ce calcul</h3></div>
              <div className="info-section-body"><p>Ce calcul permet de savoir tout de suite ce qu une hausse de 2 %, 5 % ou 10 % change sur votre remuneration de base.</p></div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Conseil utile</h3></div>
              <div className="info-section-body"><p>Gardez la meme base de comparaison pendant vos simulations: salaire mensuel brut, salaire mensuel net ou salaire annuel, mais pas un melange des trois.</p></div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Comment lire le resultat</h3></div>
              <div className="info-section-body"><p>La hausse calculee represente seulement l augmentation theorique. Pour une analyse complete, comparez ensuite l impact brut et net si votre situation l exige.</p></div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">Qu&apos;est-ce qu&apos;une augmentation de salaire ?</div>
              <div className="info-section-body">
                <div>
                  <u><h2 style={{ fontSize: "16px" }}>Le concept de l&apos;augmentation de salaire</h2></u>
                  <p>
                    L&apos;augmentation de salaire est un montant supplementaire accorde a un employe en complement
                    de son salaire mensuel. Cette hausse est generalement exprimee en pourcentage du salaire de
                    base et s&apos;ajoute au salaire apres calcul. Elle peut resulter d&apos;une excellente performance,
                    d&apos;une hausse du cout de la vie ou d&apos;une decision de la direction.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black">
                    Exemple : si votre salaire de base est 4 000 € et qu&apos;une augmentation de 5 % est accordee,
                    l&apos;augmentation est : 4 000 x 0,05 = 200 €
                  </div>
                </div>
                <hr />
                <div>
                  <u><h2 style={{ fontSize: "16px" }}>Comment calculer l&apos;augmentation</h2></u>
                  <p>Pour calculer l&apos;augmentation de salaire, suivez ces etapes :</p>
                  <ul>
                    <li>Entrez le salaire de base dans le champ prevu.</li>
                    <li>Entrez le pourcentage d&apos;augmentation.</li>
                    <li>Multipliez le salaire de base par le pourcentage pour obtenir la valeur de l&apos;augmentation.</li>
                    <li>Ajoutez ce montant au salaire de base pour obtenir le nouveau salaire.</li>
                  </ul>
                  <div className="p-3 mb-2 bg-info text-black">
                    Exemple : si votre salaire de base est 5 000 € et l&apos;augmentation est de 8 %,
                    l&apos;augmentation est : 5 000 x 0,08 = 400 €
                  </div>
                </div>
                <hr />
                <div>
                  <u><h2 style={{ fontSize: "16px" }}>Questions frequentes</h2></u>
                  <p>Reponses aux questions courantes sur l&apos;augmentation de salaire et son calcul.</p>
                  <div className="p-3 mb-2 bg-info text-black">
                    Question : Pourquoi l&apos;augmentation est-elle definie en pourcentage ?<br />
                    Reponse : Definir l&apos;augmentation en pourcentage permet d&apos;adapter le montant ajoute
                    en fonction du salaire de base, ce qui garantit une hausse equitable pour tous les employes.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default SalaryBonusCalculator;
